import React, { Component } from 'react';

export default class ErrorComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo
        }, ()=> {
            this.props?.errorHandler()
            // You can also log the error to an error reporting service
            console.error(error, errorInfo);
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div>
                    <h2>Something went wrong.</h2>
                    <p>{this.state.error && this.state.error.toString()}</p>
                    <p>Component Stack Error Details:</p>
                    <pre>{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
                </div>
            );
        }
        // If no error, render children untouched
        return this.props.children;
    }
}